import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  refreshingToken = new BehaviorSubject<boolean>(false);

  constructor() { }

  setRefreshingToken(isRefreshing: boolean) {
    this.refreshingToken.next(isRefreshing);
  }

  getRefreshingTokenStatus(): Observable<boolean> {
    return this.refreshingToken.asObservable();
  }
}
